import { Navigate, useOutletContext } from "react-router";
import type { SessionUser } from "../lib/session-loader";

export function RootRedirect() {
  const session = useOutletContext<SessionUser>();
  // New users without a defaultModule go to onboarding; everyone else lands
  // on the Vandaag dashboard (post-login default per _DECISIONS.md).
  if (!session.defaultModule) {
    return <Navigate to="/welkom" replace />;
  }
  return <Navigate to="/vandaag" replace />;
}
